/*
 * Closes the hardcoded universal clearance-code bypass, at the merchant's
 * request, for the time being.
 *
 * sat-app.js's validClearance() treats the literal string "SAT-3472" (or
 * "SAT3472") as always valid, regardless of whether any such order exists —
 * a demo/testing shortcut left in the base component. That alone would be
 * a minor issue if it were at least secret, but the exact same code is
 * printed as the example on the clearance gate itself (snippets/
 * sat-overlays.liquid) and on the Classified compartment's hint (snippets/
 * sat-classified.liquid) — so the page was handing every visitor a working
 * skeleton key to the restricted index in the same breath it asked them to
 * prove they'd ordered something. Replaces the method outright rather than
 * wrapping it, since there's nothing to add to the real behavior — only
 * something to remove: the hardcoded bypass. The real-order-number check
 * (myOrderNumbers(), unchanged) still works exactly as before.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  window.SATComponent.prototype.validClearance = function (raw) {
    const code = String(raw || '').trim().toUpperCase().replace(/\s+/g, '').replace(/[‐-―−]/g, '-');
    const mine = this.myOrderNumbers();
    return mine.includes(code) || mine.includes(code.replace(/^SAT-?/, 'SAT-'));
  };
})();
